export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10368.3f4a0a40.jpg";